module.exports = __webpack_public_path__ + "img/preindexpic.19930453.png";